import React from 'react';
import { CloseOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import {
  ChatHeader as StyledHeader,
  HeaderTitle,
  HeaderIcon,
  HeaderText,
  HeaderMainText,
  HeaderSubText,
  HeaderActions,
  HeaderButton
} from 'src/styled/Chat/ChatWindow.styled';
import LanguageSwitcher from './LanguageSwitcher';

interface IChatHeaderProps {
  onClose: () => void;
  isConnected?: boolean;
  isDraggable?: boolean;
  isDragging?: boolean;
}

export const ChatHeader: React.FC<IChatHeaderProps> = ({
  onClose,
  isConnected = false,
  isDraggable = false,
  isDragging = false
}) => {
  const { t } = useTranslation();

  // Get favicon URL from document
  const getFaviconUrl = () => {
    if (typeof window === 'undefined') return '/favicon.ico';
    const favicon = document.querySelector<HTMLLinkElement>('link[rel*="icon"]');
    return favicon?.href || '/favicon.ico';
  };

  return (
    <StyledHeader
      data-drag-handle={isDraggable ? 'true' : undefined}
      style={{
        cursor: isDragging ? 'grabbing' : isDraggable ? 'grab' : 'default'
      }}>
      <HeaderTitle>
        <HeaderIcon>
          <img
            src={getFaviconUrl()}
            alt="Bot"
            style={{
              width: '18px',
              height: '18px',
              objectFit: 'contain'
            }}
            onError={(e) => {
              // Fallback to icon if image fails to load
              e.currentTarget.style.display = 'none';
              const parent = e.currentTarget.parentElement;
              if (parent) {
                const icon = document.createElement('span');
                icon.innerHTML =
                  '<span role="img" aria-label="robot" class="anticon anticon-robot"><svg viewBox="64 64 896 896" focusable="false" data-icon="robot" width="18px" height="18px" fill="currentColor" aria-hidden="true"><path d="M300 328a60 60 0 10120 0 60 60 0 10-120 0zM852 64H172c-17.7 0-32 14.3-32 32v660c0 17.7 14.3 32 32 32h680c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-32 660H204V128h616v596zM604 328a60 60 0 10120 0 60 60 0 10-120 0zm250.2 556H169.8c-16.5 0-29.8 14.3-29.8 32v36c0 4.4 3.3 8 7.4 8h729.1c4.1 0 7.4-3.6 7.4-8v-36c.1-17.7-13.2-32-29.7-32zM664 508H360c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z"></path></svg></span>';
                parent.appendChild(icon.firstElementChild);
              }
            }}
          />
        </HeaderIcon>
        <HeaderText>
          <HeaderMainText>{t('chat.title')}</HeaderMainText>
          <HeaderSubText>
            {isConnected ? t('chat.subtitle') : t('chat.subtitleOffline')}
          </HeaderSubText>
        </HeaderText>
      </HeaderTitle>
      <HeaderActions>
        <LanguageSwitcher />
        <HeaderButton onClick={onClose} aria-label={t('chat.title')}>
          <CloseOutlined />
        </HeaderButton>
      </HeaderActions>
    </StyledHeader>
  );
};

export default ChatHeader;
